// Getters
export const SUB_IS_ERROR = 'subscription/stateSubIsError';
export const SUB_IS_LOADING = 'subscription/stateSubIsLoading';
export const SUB_IS_SELECTED = 'subscription/stateSubIsSelected';
export const SUB_GET_DATA = 'subscription/stateSubData';
export const SUB_GET_TRANSACTIONS = 'subscription/stateSubTransactions';
export const SUB_GET_FILTER = 'subscription/stateSubFilter';

//Mutations
export const SUB_MUTATION_FILTER_EMAIL = 'subscription/stateSubFilterEmail';
export const SUB_MUTATION_CLEAR_FILTER = 'subscription/stateSubFilterClear';
export const SUB_MUTATION_CLEAR_TRANSACTIONS = 'subscription/stateSubTransactionsClear';

// Actions
// export const SUB_ACTION_DATA = 'subscription/stateSubData';
export const SUB_ACTION_FILTER = 'subscription/stateSubSearchByFilter';
export const SUB_ACTION_FILTER_EMAIL = 'subscription/stateSubFilterEmail';
export const SUB_ACTION_CLEAR_FILTER = 'subscription/stateSubFilterClear';
export const SUB_ACTION_GET_TRANSACTIONS = 'subscription/stateSubTransactions';
export const SUB_ACTION_CLEAR_TRANSACTIONS = 'subscription/stateSubClearTransactions';





// WEBPACK FOOTER //
// ./src/store/types_subscription.js